var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-column w-100" },
    _vm._l(_vm.variationAttributes, function (variationAttribute) {
      return _c(
        "div",
        {
          key: variationAttribute.attribute.propertyId,
          staticClass: "fs-property d-flex mb-3 variations",
        },
        [
          _c("div", { staticClass: "headline text-uppercase" }, [
            _c("span", [
              _vm._v(_vm._s(variationAttribute.attribute.texts[_vm.lang])),
            ]),
          ]),
          _vm._v(" "),
          variationAttribute.attribute.type === "images"
            ? _c("mh-variation-image-selection", {
                attrs: {
                  "variation-id": _vm.variationId,
                  "variation-attributes": _vm.decode(
                    variationAttribute.value.values.value
                  ),
                  "preload-image-limit": _vm.preloadImageLimit,
                  lang: _vm.lang,
                },
              })
            : variationAttribute.attribute.type === "dropdown"
            ? _c("mh-variation-dropdown-selection", {
                attrs: {
                  "variation-id": _vm.variationId,
                  "variation-attributes": _vm.decode(
                    variationAttribute.value.values.value
                  ),
                  lang: _vm.lang,
                },
              })
            : variationAttribute.attribute.type === "textbox"
            ? _c("mh-variation-textbox-selection", {
                attrs: {
                  "variation-id": _vm.variationId,
                  "variation-attributes": _vm.decode(
                    variationAttribute.value.values.value
                  ),
                  lang: _vm.lang,
                },
              })
            : _vm._e(),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }